import { SystemLocation } from '../services/sbc-api.service';

export const SCAN_ELIGIBLE_TYPES = new Set(['AUTHORITY', 'ZONE', 'SECTOR', 'PLOT']);

export interface LocTreeNode {
  location: SystemLocation;
  children: LocTreeNode[];
}

export function buildLocationTree(locations: SystemLocation[]): LocTreeNode[] {
  const active = locations.filter((l) => l.statusCd === 'active');
  const byParent = new Map<number | null, SystemLocation[]>();
  for (const loc of active) {
    const pid = loc.parentLocationId ?? null;
    if (!byParent.has(pid)) byParent.set(pid, []);
    byParent.get(pid)!.push(loc);
  }
  for (const [, arr] of byParent) {
    arr.sort((a, b) => a.name.localeCompare(b.name));
  }
  const build = (parentId: number | null): LocTreeNode[] =>
    (byParent.get(parentId) || []).map((location) => ({
      location,
      children: build(location.id),
    }));
  return build(null);
}

export function collectDescendantPlots(locations: SystemLocation[], rootId: number): SystemLocation[] {
  const active = locations.filter((l) => l.statusCd === 'active');
  const byParent = new Map<number | null, SystemLocation[]>();
  for (const loc of active) {
    const pid = loc.parentLocationId ?? null;
    if (!byParent.has(pid)) byParent.set(pid, []);
    byParent.get(pid)!.push(loc);
  }

  const plots: SystemLocation[] = [];
  function walk(id: number): void {
    for (const child of byParent.get(id) || []) {
      if (child.locationTypeCode === 'PLOT') plots.push(child);
      else walk(child.id);
    }
  }
  walk(rootId);

  const root = active.find((l) => l.id === rootId);
  if (root?.locationTypeCode === 'PLOT' && !plots.some((p) => p.id === root.id)) {
    plots.unshift(root);
  }

  return plots.sort((a, b) => a.name.localeCompare(b.name));
}
